var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',_vm._b({key:_vm.imageComponentKey,staticClass:"image",attrs:{"src":_vm.loadImage},on:{"error":_vm.onError}},'v-img',_vm.imageAttrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }